import {setUploadAuthHeaders} from './auth-ui.js';
import {allowsWorkflowFolder,workflowFolderRestriction,PENDING_WORKFLOW_ID,A1_CONSTRUCTION_WORKFLOW_ID,A1_EXECUTION_WORKFLOW_ID} from '../lib/upload-workflow-policy.js';

const CHUNK=16*1024*1024;
const label={draft:'草稿',in_review:'審核中',closed:'已結案',uploading:'上傳中',ready:'待送審',pending:'待審',publishing:'入庫中',published:'已入庫',rejected:'已否決',conflict:'衝突',skipped:'已略過'};
const api=async(url,method='GET',data)=>{
  const response=await fetch(url,{method,headers:data===undefined?{}:{'Content-Type':'application/json'},...(data===undefined?{}:{body:JSON.stringify(data)})});
  const json=await response.json();if(!response.ok)throw new Error(json.error||`HTTP ${response.status}`);return json;
};
const el=(tag,text,parent,cls)=>{const node=document.createElement(tag);if(text!=null)node.textContent=text;if(cls)node.className=cls;parent.append(node);return node;};

export async function initUploadReviewUI({getState,flashHint,refreshLibrary}){
  let status;
  try{status=await api('/api/upload-requests/status');}catch{return {enabled:false,active:false,enqueue:()=>{}};}
  const dialog=document.querySelector('#uploadDialog');
  const card=dialog.querySelector('.upload-card');
  dialog.classList.add('is-review');
  document.querySelector('.upload-zip-field')?.setAttribute('hidden','');
  const sub=document.querySelector('#uploadDialogSub');
  if(sub)sub.textContent='一次上傳產生一張審核單；管理者核可後才入庫與轉檔';
  const dropHint=document.querySelector('#uploadDropHint');
  if(dropHint)dropHint.textContent='可多次加入；ZIP 僅解壓，內部檔案比照單檔審核';
  dialog.querySelector('.dz-title').textContent='拖曳檔案到此處，或按下方按鈕選擇';
  dialog.querySelector('.upload-format-help .dz-hint').textContent='支援 DWG／DXF／RVT／RFA、PDF、圖片、Office 與 ZIP。一次上傳產生一張審核單；每個檔案可指定不同目錄。ZIP 只作解壓，不解成正式套件。核可後才入庫與轉檔。';
  const section=el('section',null,card,'upload-review');
  const result=el('div',null,section,'upload-review-result');result.setAttribute('aria-live','polite');
  const draftActions=el('div',null,section,'upload-review-draft-actions');draftActions.hidden=true;
  const adminResult=document.querySelector('#uploadReviewResult');
  const workspaceResult=document.querySelector('#uploadRequestsResult');
  let active=false,currentXhr=null,cancelled=false,currentDraftId=null,noteSaveTimer=null,noteSaveSeq=0,submitting=false,discarding=false,renderedDraft=null;
  let workspaceMode='draft';
  const state=()=>getState();
  const noteField=()=>document.querySelector('#uploadRequestNote');
  const noteCount=()=>document.querySelector('#uploadRequestNoteCount');
  const workflowField=()=>document.querySelector('#uploadWorkflow');
  const syncNoteCount=()=>{const field=noteField(),count=noteCount();if(count)count.textContent=String((field?.value||'').length);};
  const readNote=()=>noteField()?.value??'';
  const readWorkflowId=()=>workflowField()?.value||'';
  const setNote=(value='')=>{const field=noteField();if(field)field.value=String(value??'');syncNoteCount();};
  const setWorkflow=(workflowId='',workflowName='')=>{
    const select=workflowField();if(!select)return;
    const id=workflowId||PENDING_WORKFLOW_ID;
    if(![...select.options].some(option=>option.value===id))select.add(new Option(workflowName||(id===PENDING_WORKFLOW_ID?'待指定':id),id));
    select.value=id;
    document.dispatchEvent(new Event('dcms-upload-workflow-set'));
  };
  const executionMode=()=>readWorkflowId()===A1_EXECUTION_WORKFLOW_ID;
  const executionStart=el('button','送出審核',section,'btn btn-primary');executionStart.type='button';executionStart.hidden=true;
  const executionInfo=el('p','送審後，管理者核可將為 C.施工圖 及其子目錄的現行文件建立 2.0 執行版；已有 2.x 版次的文件會略過。',section,'side-help');executionInfo.hidden=true;
  const updateExecutionMode=()=>{
    const enabled=executionMode();
    document.querySelector('#uploadFolder')?.closest('label')?.toggleAttribute('hidden',enabled);
    dialog.querySelector('.upload-request-note')?.toggleAttribute('hidden',enabled);
    dialog.querySelector('.upload-drop-section')?.toggleAttribute('hidden',enabled);
    executionInfo.hidden=!enabled;executionStart.hidden=!enabled||Boolean(currentDraftId);
    if(enabled)document.querySelector('#uploadProgress').hidden=true;
  };
  document.addEventListener('dcms-upload-workflow-set',updateExecutionMode);
  workflowField()?.addEventListener('change',updateExecutionMode);
  const clearNote=()=>setNote('');
  const clearWorkflow=()=>setWorkflow('');
  const draftPayload=()=>({note:readNote(),workflowId:readWorkflowId()||null});
  const persistDraft=async(requestId)=>{
    if(!requestId)return null;
    const request=(await api(`/api/upload-requests/${requestId}`,'PATCH',draftPayload())).request;
    return request;
  };
  const loadWorkflowOptions=async()=>{
    const select=workflowField();if(!select)return;
    const current=select.value,currentName=select.selectedOptions[0]?.textContent||current;
    let workflows=[];
    try{workflows=(await api('/api/upload-workflows')).workflows||[];}catch{workflows=[];}
    select.replaceChildren();
    for(const [system,label] of [[true,'系統流程'],[false,'管理者新增的流程']]){
      const group=document.createElement('optgroup');group.label=label;
      for(const workflow of workflows.filter(item=>!!item.system===system))group.append(new Option(workflow.name,workflow.id));
      if(group.children.length)select.append(group);
    }
    if(![...select.options].some(option=>option.value===PENDING_WORKFLOW_ID))select.add(new Option('待指定',PENDING_WORKFLOW_ID));
    if(current&&select.disabled&&![...select.options].some(option=>option.value===current))select.add(new Option(currentName,current));
    if(current&&[...select.options].some(option=>option.value===current))select.value=current;
    document.dispatchEvent(new Event('dcms-upload-workflow-set'));
  };
  const scheduleNoteSave=()=>{
    syncNoteCount();
    if(!currentDraftId)return;
    clearTimeout(noteSaveTimer);
    const seq=++noteSaveSeq;
    noteSaveTimer=setTimeout(async()=>{
      try{await persistDraft(currentDraftId);}catch(e){if(seq===noteSaveSeq)flashHint(e.message);}
    },400);
  };
  noteField()?.addEventListener('input',scheduleNoteSave);
  noteField()?.addEventListener('change',()=>{
    syncNoteCount();
    if(!currentDraftId)return;
    clearTimeout(noteSaveTimer);
    const requestId=currentDraftId;
    persistDraft(requestId).catch(e=>{if(!discarding&&currentDraftId===requestId)flashHint(e.message);});
  });
  workflowField()?.addEventListener('change',()=>{
    if(!currentDraftId)return;
    clearTimeout(noteSaveTimer);
    const requestId=currentDraftId;
    persistDraft(requestId).catch(e=>{if(!discarding&&currentDraftId===requestId)flashHint(e.message);});
  });
  syncNoteCount();
  await loadWorkflowOptions();
  const folderText=(projectId,folderId)=>{
    const names=[],folders=state().folders;let id=folderId;const seen=new Set();
    while(id&&!seen.has(id)){seen.add(id);const folder=folders.find(f=>f.id===id&&f.projectId===projectId);if(!folder)break;names.unshift(folder.name);id=folder.parentId;}
    return names.length?names.join(' / '):'專案根目錄';
  };
  const fullFolderText=(projectId,folderId)=>{
    const project=state().projects.find(p=>p.id===projectId);
    const names=[];let id=folderId;const seen=new Set();
    while(id){
      if(seen.has(id))return `${project?.name||'專案（無法取得）'} / 目錄路徑無法取得`;
      seen.add(id);
      const folder=state().folders.find(f=>f.id===id&&f.projectId===projectId);
      if(!folder)return `${project?.name||'專案（無法取得）'} / 目錄路徑無法取得`;
      names.unshift(folder.name);id=folder.parentId;
    }
    return [project?.name||'專案（無法取得）',...names].join(' / ');
  };
  const folderSelect=(projectId,value,parent,onChange,workflowId)=>{
    const wrap=el('label',null,parent,'upload-review-file-dest');
    el('span','目標目錄',wrap);
    const select=el('select',null,wrap);select.setAttribute('aria-label','目標目錄');
    if(allowsWorkflowFolder(workflowId,projectId,null,state().folders))select.add(new Option('專案根目錄',''));
    for(const folder of state().folders.filter(f=>f.projectId===projectId)){
      if(!window.dcmsAuth?.can('upload.request.create',{projectId,folderId:folder.id}))continue;
      if(!allowsWorkflowFolder(workflowId,projectId,folder.id,state().folders))continue;
      select.add(new Option(folderText(projectId,folder.id),folder.id));
    }
    if(![...select.options].some(option=>option.value===(value||''))){
      const missing=new Option(select.options.length?'請選擇允許的目錄':'沒有可選目錄','');missing.disabled=true;select.add(missing,0);
    }
    select.value=value||'';select.addEventListener('change',()=>onChange(select.value));return select;
  };
  const showProgress=(name,loaded,total,index=1,count=1)=>{
    const panel=document.querySelector('#uploadProgress');panel.hidden=false;
    document.querySelector('#uploadProgressLabel').textContent=`檔案 ${index} / ${count} · 暫存 ${name}`;
    document.querySelector('#uploadProgressDetail').textContent=`${(loaded/1048576).toFixed(1)} / ${(total/1048576).toFixed(1)} MiB`;
    const pct=total?Math.round(loaded/total*100):100;
    document.querySelector('#uploadProgressPct').textContent=`${pct}%`;
    document.querySelector('#uploadProgressBar').style.width=`${pct}%`;
  };
  const sendChunk=(url,blob,onProgress)=>new Promise((resolve,reject)=>{
    const xhr=new XMLHttpRequest();currentXhr=xhr;xhr.open('PATCH',url);setUploadAuthHeaders(xhr);
    xhr.timeout=10*60*60*1000;xhr.setRequestHeader('Content-Type','application/octet-stream');
    xhr.upload.onprogress=e=>onProgress(e.loaded);
    xhr.onload=()=>{let data={};try{data=JSON.parse(xhr.responseText);}catch{}xhr.status>=200&&xhr.status<300?resolve(data):reject(new Error(data.error||`HTTP ${xhr.status}`));};
    xhr.onerror=()=>reject(new Error('網路錯誤，上傳中斷'));xhr.ontimeout=()=>reject(new Error('上傳逾時'));xhr.onabort=()=>reject(new Error('已取消上傳'));
    xhr.onloadend=()=>{if(currentXhr===xhr)currentXhr=null;};xhr.send(blob);
  });
  const sendFile=async(requestId,entry,inputFile,start=0,index=1,count=1)=>{
    let offset=start;
    while(offset<inputFile.size){
      if(cancelled)throw new Error('已取消上傳；草稿保留');
      const end=Math.min(offset+CHUNK,inputFile.size);
      showProgress(inputFile.name,offset,inputFile.size,index,count);
      const response=await sendChunk(`/api/upload-requests/${requestId}/files/${entry.id}/content?offset=${offset}`,inputFile.slice(offset,end),n=>showProgress(inputFile.name,offset+n,inputFile.size,index,count));
      offset=response.received;
    }
    showProgress(inputFile.name,inputFile.size,inputFile.size,index,count);
    await api(`/api/upload-requests/${requestId}/files/${entry.id}/complete`,'POST',{});
  };
  const showSubmitted=()=>{
    renderedDraft=null;
    draftActions.hidden=true;draftActions.replaceChildren();
    result.replaceChildren();
    const done=el('div',null,result,'upload-review-submitted');
    el('strong','已送出審核單',done);
    el('p','請到左側「審核單 → 進行中審核單」查看進度。',done);
  };
  const syncDraftActions=()=>{
    const busy=active||submitting||discarding;
    for(const select of result.querySelectorAll('.upload-review-file-phase select,.upload-review-file-dest select'))select.disabled=busy;
    for(const button of result.querySelectorAll('[data-draft-resume]'))button.disabled=busy;
    if(noteField())noteField().disabled=discarding;
    const request=renderedDraft;
    const submit=draftActions.querySelector('[data-draft-action="submit"]');
    const addMore=draftActions.querySelector('[data-draft-action="add"]');
    const discard=draftActions.querySelector('[data-draft-action="discard"]');
    if(!request||!submit)return;
    const execution=request.workflowId===A1_EXECUTION_WORKFLOW_ID;
    const notReady=request.files.filter(file=>file.status!=='ready').length;
    if(addMore)addMore.disabled=busy;
    if(discard)discard.disabled=busy;
    submit.disabled=busy||(!execution&&(!request.files.length||notReady>0));
    if(!execution&&!request.files.length)submit.title='請先加入檔案';
    else if(notReady)submit.title=`尚有 ${notReady} 個檔案未完成暫存`;
    else if(active)submit.title='檔案上傳中，請稍候';
    else if(submitting)submit.title='送出審核中，請稍候';
    else submit.removeAttribute('title');
  };
  const renderDraft=request=>{
    if(discarding){flashHint('草稿處理中，請稍候');return;}
    if(!dialog.open)dialog.showModal();
    currentDraftId=request.id;
    renderedDraft=request;
    setNote(request.note||'');
    setWorkflow(request.workflowId||'',request.workflowName||'');
    const projectSelect=document.querySelector('#uploadProject');
    if(projectSelect.value!==request.projectId){projectSelect.value=request.projectId;projectSelect.dispatchEvent(new Event('change'));}
    projectSelect.disabled=true;
    workflowField().disabled=request.files.length>0||request.workflowId===A1_EXECUTION_WORKFLOW_ID;
    updateExecutionMode();
    result.replaceChildren();
    const head=el('div',null,result,'upload-review-draft-head');
    el('h3',`審核單草稿 ${request.id}`,head);
    el('p',request.workflowId===A1_EXECUTION_WORKFLOW_ID?'確認專案及流程後送審。':`已暫存 ${request.files.length} 個檔案。確認申請說明與各檔目錄後送審；可繼續加入檔案。`,head,'side-help');
    if(request.workflowName){
      const workflowPreview=el('div',null,result,'upload-review-request-note');
      el('strong','流程',workflowPreview);
      el('p',request.workflowName,workflowPreview);
    }
    if(request.note?.trim()){
      const notePreview=el('div',null,result,'upload-review-request-note');
      el('strong','申請說明',notePreview);
      el('p',request.note,notePreview);
    }
    const list=el('div',null,result,'upload-review-files');
    if(!request.files.length&&request.workflowId!==A1_EXECUTION_WORKFLOW_ID)el('p','尚未加入檔案，請從上方拖曳或選擇檔案。',list,'side-help');
    for(const file of request.files){
      const row=el('div',null,list,'upload-review-file is-draft');row.dataset.status=file.status;
      if(request.workflowId===A1_CONSTRUCTION_WORKFLOW_ID)row.classList.add('is-a1');
      const info=el('div',null,row,'upload-review-file-info');
      el('strong',file.name,info);
      if(file.sourcePath)el('small',`ZIP 路徑：${file.sourcePath}`,info);
      el('span',label[file.status]||file.status,row,`upload-review-status is-${file.status}`);
      folderSelect(request.projectId,file.folderId,row,async folderId=>{
        if(active||submitting||discarding)return;
        active=true;syncDraftActions();
        try{
          request=(await api(`/api/upload-requests/${request.id}/files/${file.id}`,'PATCH',{folderId})).request;
          flashHint(`已更新 ${file.name} 的目錄`);
          renderDraft(request);
        }catch(e){flashHint(e.message);renderDraft((await api(`/api/upload-requests/${request.id}`)).request);}
        finally{active=false;syncDraftActions();}
      },request.workflowId);
      if(request.workflowId===A1_CONSTRUCTION_WORKFLOW_ID&&file.a1Action==='execute')el('small','舊草稿已指定轉為 2.0 執行版',row,'side-help');
      if(file.status==='uploading'){
        const actions=el('div',null,row,'upload-review-file-actions');
        const resume=el('button',`續傳（${(file.received/1048576).toFixed(1)} MiB）`,actions,'btn btn-sm');resume.type='button';
        resume.dataset.draftResume='';
        resume.onclick=()=>{
          const picker=document.createElement('input');picker.type='file';
          picker.onchange=async()=>{
            const chosen=picker.files?.[0];if(!chosen)return;
            if(chosen.name!==file.name||chosen.size!==file.size){flashHint('請選擇相同檔名與大小的原始檔');return;}
            resume.disabled=true;active=true;cancelled=false;syncDraftActions();
            try{await sendFile(request.id,file,chosen,file.received);renderDraft((await api(`/api/upload-requests/${request.id}`)).request);}
            catch(e){flashHint(e.message);renderDraft((await api(`/api/upload-requests/${request.id}`)).request);}
            finally{active=false;document.querySelector('#uploadProgress').hidden=true;syncDraftActions();}
          };picker.click();
        };
      }
    }
    draftActions.hidden=false;draftActions.replaceChildren();
    const discard=el('button','放棄草稿',draftActions,'btn btn-sm btn-danger');discard.type='button';
    discard.dataset.draftAction='discard';
    discard.onclick=async()=>{
      if(active||submitting||discarding)return;
      if(!confirm(`確定放棄草稿 ${request.id}？其中 ${request.files.length} 個檔案的暫存資料也會刪除。`))return;
      const requestId=request.id;
      discarding=true;clearTimeout(noteSaveTimer);noteSaveSeq++;syncDraftActions();
      try{
        await api(`/api/upload-requests/${requestId}`,'DELETE');
        if(currentDraftId===requestId){
          currentDraftId=null;renderedDraft=null;
          document.querySelector('#uploadProject').disabled=false;workflowField().disabled=false;
          clearNote();clearWorkflow();
          draftActions.hidden=true;draftActions.replaceChildren();result.replaceChildren();
          document.querySelector('#fileInput').value='';
          document.querySelector('#uploadProgress').hidden=true;
        }
        flashHint('已放棄草稿');
      }catch(e){
        flashHint(e.message||String(e));
        if(currentDraftId===requestId)scheduleNoteSave();
      }finally{discarding=false;syncDraftActions();}
    };
    let addMore=null;
    if(request.workflowId!==A1_EXECUTION_WORKFLOW_ID){addMore=el('button','繼續加入檔案',draftActions,'btn btn-sm');addMore.type='button';addMore.dataset.draftAction='add';addMore.onclick=()=>document.querySelector('#fileInput').click();}
    const submit=el('button',request.workflowId===A1_EXECUTION_WORKFLOW_ID?'送出審核':`送出審核（${request.files.length} 個檔案）`,draftActions,'btn btn-primary');
    submit.type='button';
    submit.dataset.draftAction='submit';
    syncDraftActions();
    submit.onclick=async()=>{
      if(submitting||discarding)return;
      if(active){flashHint('檔案仍在上傳，請完成後再送審');return;}
      submitting=true;syncDraftActions();
      const requestId=request.id;
      const payload=draftPayload();
      try{
        clearTimeout(noteSaveTimer);noteSaveSeq++;
        // 申請說明／流程一併在送審時寫入，避免舊後端沒有 PATCH 時失敗。
        try{await persistDraft(requestId);}catch{/* submit 會帶欄位 */}
        const latest=(await api(`/api/upload-requests/${requestId}`)).request;
        if(latest.status!=='draft')throw new Error('此審核單已送審或不可再送');
        if(latest.workflowId!==A1_EXECUTION_WORKFLOW_ID&&(!latest.files.length||latest.files.some(f=>f.status!=='ready'))){
          renderDraft(latest);
          throw new Error('尚有檔案未完成暫存，請完成後再送審');
        }
        await api(`/api/upload-requests/${requestId}/submit`,'POST',payload);
        currentDraftId=null;clearNote();clearWorkflow();projectSelect.disabled=false;workflowField().disabled=false;
        flashHint('已送出上傳審核單，核可後才會入庫及轉檔');
        showSubmitted();
      }catch(e){
        flashHint(e.message||String(e));
        try{renderDraft((await api(`/api/upload-requests/${requestId}`)).request);}
        catch{submit.disabled=false;if(addMore)addMore.disabled=false;}
      }finally{submitting=false;syncDraftActions();}
    };
  };
  executionStart.onclick=async()=>{
    if(active||submitting||discarding||currentDraftId)return;
    const projectId=document.querySelector('#uploadProject').value;if(!projectId){flashHint('請先選擇專案');return;}
    submitting=true;executionStart.disabled=true;
    try{const request=(await api('/api/upload-requests','POST',{projectId,workflowId:A1_EXECUTION_WORKFLOW_ID})).request;submitting=false;renderDraft(request);setTimeout(()=>draftActions.querySelector('[data-draft-action=submit]')?.click(),0);}
    catch(e){flashHint(e.message||String(e));}
    finally{submitting=false;executionStart.disabled=false;syncDraftActions();}
  };
  const showList=async(adminOnly=false,mode=null)=>{
    const target=adminOnly?adminResult:workspaceResult;
    const requests=(await api('/api/upload-requests')).requests.filter(r=>adminOnly?r.status==='in_review':r.ownerId===window.dcmsAuth?.user?.id&&r.status===mode);
    const title=adminOnly?'待審上傳':({draft:'審核單草稿',in_review:'進行中審核單',closed:'已結案審核單'}[mode]);
    target.replaceChildren();el('p',`${title} · ${requests.length} 張`,target,'upload-review-list-summary');
    if(!requests.length){el('p',`目前沒有${title}`,target);return;}
    const search=el('input',null,target);search.type='search';search.placeholder='搜尋檔名、單號或 ZIP 路徑';search.setAttribute('aria-label','搜尋審核單');
    el('p','點選單號可展開或收合檔案明細。',target,'side-help');
    const list=el('div',null,target,'upload-review-files');
    const render=()=>{
      list.replaceChildren();let shown=0;
      for(const request of requests){
        const haystack=`${request.note||''} ${request.workflowName||''} ${request.files.map(f=>`${f.name} ${f.sourcePath||''}`).join(' ')} ${request.id}`.toLowerCase();
        if(search.value&&!haystack.includes(search.value.toLowerCase()))continue;
        const execution=request.workflowId===A1_EXECUTION_WORKFLOW_ID;
        const files=request.files.filter(f=>execution||!adminOnly||['pending','conflict'].includes(f.status));
        if(!files.length&&!(request.status==='draft'&&!request.files.length))continue;
        const group=el('details',null,list,'upload-review-group');
        const isDraftList=!adminOnly&&request.status==='draft';
        if(isDraftList)group.classList.add('is-draft-list');
        shown++;
        group.open=shown===1||Boolean(search.value);
        const summary=el('summary',null,group,'upload-review-summary');
        if(isDraftList){
          const heading=el('div',null,summary,'upload-draft-heading');
          const identity=el('div',null,heading,'upload-draft-identity');
          el('span','審核單草稿',identity,'upload-draft-kicker');
          el('h4',`單號 ${request.id}`,identity);
          el('span','草稿',heading,'upload-draft-badge');
        }else el('h4',`單號: ${request.id} · 狀態: ${label[request.status]||request.status} · 發起人: ${request.ownerName||'未知'}`,summary);
        const project=state().projects.find(p=>p.id===request.projectId)?.name||request.projectId;
        const meta=el('div',null,summary,'upload-review-summary-meta');
        el('span',`專案：${project}`,meta);
        if(request.workflowName||isDraftList)el('span',`流程：${request.workflowName||'待指定'}`,meta);
        el('span',`檔案：${request.files.length}`,meta);
        if(isDraftList)el('span',`發起人：${request.ownerName||'未知'}`,meta);
        if(request.submittedAt)el('span',`送審：${new Date(request.submittedAt).toLocaleString('zh-TW')}`,meta);
        else el('span',`建立：${new Date(request.createdAt).toLocaleString('zh-TW')}`,meta);
        if(request.note?.trim()&&!isDraftList)el('span',`申請說明：${request.note.trim().slice(0,80)}${request.note.trim().length>80?'…':''}`,meta,'upload-review-note-preview');
        const counts=new Map();for(const file of request.files)counts.set(file.status,(counts.get(file.status)||0)+1);
        if(counts.size){
          const summaryCounts=el('div',null,summary,'upload-review-counts');
          for(const [fileStatus,count] of counts)el('span',`${label[fileStatus]||fileStatus} ${count}`,summaryCounts,`upload-review-count is-${fileStatus}`);
        }
        const content=el('div',null,group,'upload-review-group-content');
        if(request.workflowName&&!isDraftList){
          const workflowBlock=el('div',null,content,'upload-review-request-note');
          el('strong','流程',workflowBlock);
          el('p',request.workflowName,workflowBlock);
        }
        if(request.note?.trim()){
          const noteBlock=el('div',null,content,'upload-review-request-note');
          el('strong','申請說明',noteBlock);
          el('p',request.note,noteBlock);
        }
        if(request.status==='draft'&&request.ownerId===window.dcmsAuth?.user?.id){
          const actions=el('div',null,content,'upload-review-group-actions');
          const open=el('button','繼續草稿',actions,'btn btn-sm btn-primary');open.type='button';open.onclick=()=>renderDraft(request);
          const remove=el('button','刪除草稿',actions,'btn btn-sm btn-danger');remove.type='button';
          remove.onclick=async()=>{
            if(active&&currentDraftId===request.id){flashHint('檔案上傳中，請先等待或取消上傳');return;}
            if(!confirm(`確定刪除草稿 ${request.id}？其中 ${request.files.length} 個檔案的暫存資料也會刪除。`))return;
            remove.disabled=true;
            try{
              await api(`/api/upload-requests/${request.id}`,'DELETE');
              if(currentDraftId===request.id){
                currentDraftId=null;renderedDraft=null;clearNote();clearWorkflow();document.querySelector('#uploadProject').disabled=false;workflowField().disabled=false;
                draftActions.hidden=true;draftActions.replaceChildren();result.replaceChildren();
              }
              flashHint('已刪除審核單草稿');await showList(adminOnly,mode);
            }catch(e){flashHint(e.message);remove.disabled=false;}
          };
        }
        if(execution&&adminOnly&&status.admin){
          if(request.executionError)el('p',request.executionError,content,'side-help');
          const actions=el('div',null,content,'upload-review-group-actions');
          for(const decision of (request.executionDecision?['approve']:['approve','reject'])){
            const button=el('button',decision==='approve'?(request.executionDecision?'重試處理':'整單核可'):'整單否決',actions,'btn btn-sm');button.type='button';
            button.onclick=async()=>{const note=decision==='reject'?prompt('否決此審核單的理由'):'';if(decision==='reject'&&!note?.trim())return;if(decision==='approve'&&!confirm('確定核可整張執行版審核單？'))return;for(const b of actions.querySelectorAll('button'))b.disabled=true;try{const response=await api(`/api/upload-requests/${request.id}/execution`,'POST',{decision,note,expectedUpdatedAt:request.updatedAt});flashHint(response.request.executionError||'審核單已處理');await refreshLibrary({silent:true});await showList(true);}catch(e){flashHint(e.message);for(const b of actions.querySelectorAll('button'))b.disabled=false;}};
          }
        }
        if(isDraftList)el('h5',`檔案清單（${request.files.length}）`,content,'upload-draft-files-heading');
        if(!request.files.length)el('p','尚未加入檔案',content,isDraftList?'upload-draft-empty':'side-help');
        for(const file of files.slice(0,200)){
          const row=el('div',null,content,'upload-review-file');row.dataset.status=file.status;
          const info=el('div',null,row,'upload-review-file-info');
          el('strong',file.name,info);
          if(file.sourcePath)el('small',`ZIP 路徑：${file.sourcePath}`,info);
          el('small',`目標目錄：${request.status==='closed'&&!adminOnly?fullFolderText(request.projectId,file.folderId):folderText(request.projectId,file.folderId)}`,info);
          if(request.workflowId===A1_CONSTRUCTION_WORKFLOW_ID&&file.a1Action==='execute')el('small','舊單設定：轉為執行版（2.0）',info);
          el('span',label[file.status]||file.status,row,`upload-review-status is-${file.status}`);
          const fileActions=el('div',null,row,'upload-review-file-actions');
          if(!execution){const download=el('a','下載原檔',fileActions,'btn btn-sm');download.href=`/api/upload-requests/${request.id}/files/${file.id}/download`;}
          if(!execution&&adminOnly&&status.admin&&['pending','conflict'].includes(file.status))for(const decision of ['approve','reject']){
            const button=el('button',decision==='approve'?'核可':'否決',fileActions,'btn btn-sm');button.type='button';
            button.onclick=async()=>{
              const note=decision==='reject'?prompt(`否決 ${file.name} 的理由`):'';
              if(decision==='reject'&&!note?.trim())return;
              button.disabled=true;
              try{await api(`/api/upload-requests/${request.id}/files/${file.id}/${decision}`,'POST',{note,version:file.version});flashHint(`${file.name}：${decision==='approve'?'已核可入庫':'已否決'}`);await refreshLibrary({silent:true});await showList(adminOnly);}
              catch(e){flashHint(e.message);button.disabled=false;}
            };
          }
          if(file.decisionNote)el('small',`審核說明：${file.decisionNote}`,row,'upload-review-decision-note');
        }
        if(files.length>200)el('p',`此單另有 ${files.length-200} 個檔案；請使用搜尋縮小範圍`,content,'side-help');
      }
      if(!shown)el('p','沒有符合的檔案',list);
    };
    search.oninput=render;render();
  };
  const renderWorkspace=()=>showList(false,workspaceMode).catch(e=>flashHint(e.message));
  document.querySelector('.primary-nav [data-workspace="uploadRequests"]').hidden=false;
  document.querySelector('#uploadRequestsRefresh').addEventListener('click',renderWorkspace);
  document.addEventListener('dcms-upload-requests-open',renderWorkspace);
  for(const button of document.querySelectorAll('[data-review-list]'))button.addEventListener('click',()=>{
    workspaceMode=button.dataset.reviewList;
    for(const entry of document.querySelectorAll('[data-review-list]')){
      const selected=entry===button;entry.classList.toggle('is-active',selected);entry.setAttribute('aria-pressed',String(selected));
    }
    document.querySelector('#uploadRequestsHeading').textContent={draft:'審核單草稿',in_review:'進行中審核單',closed:'已結案審核單'}[workspaceMode];
    renderWorkspace();
  });
  if(status.admin){
    document.querySelector('#uploadReviewJump').hidden=false;
    document.querySelector('#uploadWorkflowsJump').hidden=false;
    const refresh=()=>showList(true).catch(e=>flashHint(e.message));
    document.querySelector('#uploadReviewRefresh').addEventListener('click',refresh);
    document.addEventListener('dcms-upload-review-open',refresh);
    const workflowsResult=document.querySelector('#uploadWorkflowsResult');
    const workflowsStatus=document.querySelector('#uploadWorkflowsStatus');
    const setWorkflowStatus=text=>{if(workflowsStatus)workflowsStatus.textContent=text||'';};
    const renderWorkflowAdmin=async()=>{
      if(!workflowsResult)return;
      setWorkflowStatus('讀取流程…');
      const workflows=(await api('/api/upload-workflows?manage=1')).workflows||[];
      workflowsResult.replaceChildren();
      if(!workflows.length)el('p','尚未建立流程。新增後，上傳對話框的「流程」即可選擇。',workflowsResult,'side-help');
      for(const workflow of workflows){
        const row=el('div',null,workflowsResult,'upload-workflow-row');
        if(workflow.system){
          el('strong',workflow.name,row);
          el('span','系統流程',row,'upload-workflow-system');
          el('span','固定啟用',row,'upload-workflow-system');
          continue;
        }
        const name=el('input',null,row);name.type='text';name.value=workflow.name;name.maxLength=80;name.setAttribute('aria-label',`流程名稱 ${workflow.name}`);
        const enabled=el('label',null,row,'upload-workflow-enabled');
        const check=el('input',null,enabled);check.type='checkbox';check.checked=workflow.enabled;
        enabled.append(' 啟用');
        const save=el('button','保存',row,'btn btn-sm');save.type='button';
        save.onclick=async()=>{
          save.disabled=true;
          try{
            await api(`/api/upload-workflows/${workflow.id}`,'PATCH',{name:name.value,enabled:check.checked});
            flashHint(`已更新流程「${name.value.trim()||workflow.name}」`);
            await renderWorkflowAdmin();await loadWorkflowOptions();
          }catch(e){flashHint(e.message);save.disabled=false;}
        };
        const remove=el('button','刪除',row,'btn btn-sm btn-danger');remove.type='button';
        remove.onclick=async()=>{
          if(!confirm(`確定刪除流程「${workflow.name}」？既有審核單仍保留當時名稱。`))return;
          remove.disabled=true;
          try{
            await api(`/api/upload-workflows/${workflow.id}`,'DELETE');
            flashHint('已刪除流程');
            await renderWorkflowAdmin();await loadWorkflowOptions();
          }catch(e){flashHint(e.message);remove.disabled=false;}
        };
      }
      setWorkflowStatus(`共 ${workflows.length} 個流程`);
    };
    document.querySelector('#uploadWorkflowsRefresh')?.addEventListener('click',()=>renderWorkflowAdmin().catch(e=>{setWorkflowStatus('');flashHint(e.message);}));
    document.addEventListener('dcms-upload-workflows-open',()=>renderWorkflowAdmin().catch(e=>{setWorkflowStatus('');flashHint(e.message);}));
    document.querySelector('#uploadWorkflowCreate')?.addEventListener('submit',async event=>{
      event.preventDefault();
      const input=document.querySelector('#uploadWorkflowName');
      const name=input?.value?.trim()||'';
      if(!name){flashHint('請填寫流程名稱');return;}
      try{
        await api('/api/upload-workflows','POST',{name,enabled:true});
        if(input)input.value='';
        flashHint(`已新增流程「${name}」`);
        await renderWorkflowAdmin();await loadWorkflowOptions();
      }catch(e){flashHint(e.message);}
    });
  }
  dialog.addEventListener('close',()=>{loadWorkflowOptions().catch(()=>{});});
  return {
    enabled:true,get active(){return active;},
    cancel(){cancelled=true;currentXhr?.abort();},
    async enqueue(input,{revisionOf=null}={}){
      if(active||submitting||discarding)throw new Error('草稿正在處理中，請稍候');
      if(executionMode()){flashHint('執行版流程不能上傳檔案');return;}
      const files=[...input];if(!files.length)return;
      const projectId=revisionOf?state().items.find(i=>i.id===revisionOf)?.projectId:document.querySelector('#uploadProject').value;
      const folderId=revisionOf?state().items.find(i=>i.id===revisionOf)?.folderId:document.querySelector('#uploadFolder').value||null;
      if(!projectId){flashHint('請先選擇專案');return;}
      if(!allowsWorkflowFolder(readWorkflowId(),projectId,folderId,state().folders)){flashHint(workflowFolderRestriction(readWorkflowId()));return;}
      if(!dialog.open)dialog.showModal();
      active=true;cancelled=false;let request;syncDraftActions();
      document.querySelector('#uploadProject').disabled=true;
      workflowField().disabled=true;
      try{
        if(currentDraftId){
          clearTimeout(noteSaveTimer);
          request=(await persistDraft(currentDraftId))||(await api(`/api/upload-requests/${currentDraftId}`)).request;
        }else{
          request=(await api('/api/upload-requests','POST',{projectId,...draftPayload()})).request;
        }
        if(request.status!=='draft')throw new Error('目前審核單已送審，請重新選擇檔案建立新單');
        if(request.projectId!==projectId)throw new Error('這張審核單已指定其他專案，請先完成送審');
        currentDraftId=request.id;
        setNote(request.note||'');
        setWorkflow(request.workflowId||'',request.workflowName||'');
        for(const [index,inputFile] of files.entries()){
          if(cancelled)throw new Error('已取消上傳；草稿保留在左側「審核單草稿」');
          showProgress(inputFile.name,0,inputFile.size,index+1,files.length);
          const entry=(await api(`/api/upload-requests/${request.id}/files`,'POST',{name:inputFile.name,size:inputFile.size,folderId,revisionOf})).file;
          await sendFile(request.id,entry,inputFile,0,index+1,files.length);
          request=(await api(`/api/upload-requests/${request.id}`)).request;
        }
        clearTimeout(noteSaveTimer);
        request=(await persistDraft(request.id))||request;
        renderDraft(request);
      }catch(e){
        flashHint(e.message);
        if(request?.status==='draft'){
          try{clearTimeout(noteSaveTimer);request=(await persistDraft(request.id))||(await api(`/api/upload-requests/${request.id}`)).request;}
          catch{request=(await api(`/api/upload-requests/${request.id}`)).request;}
          renderDraft(request);
        }
        else if(request){currentDraftId=null;document.querySelector('#uploadProject').disabled=false;workflowField().disabled=false;}
      }
      finally{
        active=false;
        workflowField().disabled=Boolean(request?.files.length);
        document.querySelector('#uploadProject').disabled=Boolean(currentDraftId);
        document.querySelector('#uploadProgress').hidden=true;
        syncDraftActions();
      }
    }
  };
}
